// src/components/layout/BackButton.js — "← Back" to the screen you were just on
// [marker: back-tags v1]
// Uses the browser history, so it goes exactly where the browser's Back would. When the page was
// opened directly (a bookmark or a new tab, so there's nothing to go back to) it goes one level up
// instead: /events/27 → /events, /invoices/5 → /invoices.
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function BackButton({ home = '/', style }) {
  const navigate = useNavigate();
  const location = useLocation();
  const hasHistory = location.key !== 'default';
  const parts = location.pathname.split('/').filter(Boolean);
  const parent = parts.length > 1 ? '/' + parts.slice(0, -1).join('/') : home;
  if (!hasHistory && location.pathname === home) return null;
  return (
    <button type="button" className="btn btn-ghost btn-sm back-btn" onClick={() => (hasHistory ? navigate(-1) : navigate(parent))}
            title={hasHistory ? 'Back to the previous screen' : 'Up one level'} style={{ whiteSpace: 'nowrap', ...style }}>
      ← Back
    </button>
  );
}
